import React from "react";
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import { DischargePlanningFormValues } from "./interface";

interface EditFieldsProps {
  formValues: DischargePlanningFormValues;
  handleChange: (
    field: keyof DischargePlanningFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <Grid item xs={12}>
        <FormControl>
          <FormLabel>Is the client currently fading services with AnswersNow?</FormLabel>
          <RadioGroup
            value={formValues.isFadingServices}
            onChange={handleChange("isFadingServices")}
          >
            <FormControlLabel value="YES" control={<Radio />} label="Yes" />
            <FormControlLabel value="NO" control={<Radio />} label="No" />
          </RadioGroup>
        </FormControl>
      </Grid>
      <LabeledTextArea
        multiline
        label="Fading plan"
        value={formValues.fadingPlan}
        onChange={handleChange("fadingPlan")}
        disabled={formValues.isFadingServices !== "YES"}
      />
    </Grid>
  );
};

export default EditFields;
